import JaimyGrid from '../../../../theme/components/layout/Grid';
import { IUser } from '../../../../types/User';
import { ComponentIsVisible } from '../../../utils/isVisible';
import { EVerifiedStatus } from '../../../../constants/verifiedStatus';
import { FormattedMessage } from 'react-intl';
import theme from '../../../../theme';
import JaimyText from '../../../../theme/components/Typography/Text';
import { AnchorExternal } from '../../../common/Link';
import getLocale from '../../../../getLocale';

interface IBannerRestrictionOtherProps {
  user: IUser;
}

export function BannerRestrictionOther({ user }: IBannerRestrictionOtherProps) {
  const locale = getLocale() === 'nl' ? 'nl_BE' : 'fr_BE';

  return (
    <ComponentIsVisible when={user.verified_status === EVerifiedStatus.RestrictedOther}>
      <JaimyGrid backgroundColor={theme.colors.secondary.lighter}>
        <JaimyGrid
          alignItems="center"
          padding=".75rem"
          columnGap=".5rem"
          margin="0 auto"
          maxWidth="1200px"
        >
          <JaimyText textAlign="center" color={theme.colors.white}>
            <FormattedMessage id="mainheader.banner.other" />
            <AnchorExternal
              href={`https://portal.jaimy.be/${locale}/forms-local-free`}
              className="bannerLink"
            >
              <FormattedMessage id="mainheader.banner.other.link" />
            </AnchorExternal>
          </JaimyText>
        </JaimyGrid>
      </JaimyGrid>
    </ComponentIsVisible>
  );
}
